import React, { useState } from "react";
import { Card, Collapse, Rate } from "antd";
import ScoreCardItem from "./ScoreCardItem";

const ToggleTitle = ({ titleData }) =>
  <div className="flex justify-between">
        <h2 className="font-medium mb-2">{titleData?.field.toUpperCase()} ({titleData?.weight_used * 100 }%)</h2>
        <div className="flex gap-4">
            <Rate size="small" disabled={true} allowHalf defaultValue={ titleData?.score_0_100 / 20 } />
            <div className="font-medium">{ titleData?.score_0_100 }</div>
        </div>
    </div>;

const CandidateScoreCard = ({scoreData, isClientUser=false}) => {
    const [expanded, setExpanded] = useState(!isClientUser);

    const items = [
        {
            key: '1',
            label: <ToggleTitle titleData={scoreData?.jar_breakdown?.skills} />,
            children: <ScoreCardItem scoreItem={scoreData?.jar_breakdown?.skills}/>,
        },
        {
            key: '2',
            label: <ToggleTitle titleData={scoreData?.jar_breakdown?.experience} />,
            children: <ScoreCardItem scoreItem={scoreData?.jar_breakdown?.experience}/>,
        },
        {
            key: '3',
            label: <ToggleTitle titleData={scoreData?.jar_breakdown?.education} />,
            children: <ScoreCardItem scoreItem={scoreData?.jar_breakdown?.education}/>,
        },
        {
            key: '4',
            label: <ToggleTitle titleData={scoreData?.jar_breakdown?.communication} />,
            children: <ScoreCardItem scoreItem={scoreData?.jar_breakdown?.communication}/>,
        },
        {
            key: '5',
            label: <ToggleTitle titleData={scoreData?.jar_breakdown?.trajectory} />,
            children: <ScoreCardItem scoreItem={scoreData?.jar_breakdown?.trajectory}/>,
        },
        {
            key: '6',
            label: <ToggleTitle titleData={scoreData?.jar_breakdown?.impact} />,
            children: <ScoreCardItem scoreItem={scoreData?.jar_breakdown?.impact}/>,
        },
        {
            key: '7',
            label: <ToggleTitle titleData={scoreData?.jar_breakdown?.risk} />,
            children: <ScoreCardItem scoreItem={scoreData?.jar_breakdown?.risk}/>,
        },
    ];

    return (
        <div className="bg-white rounded-2xl">
            <Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-emerald-200 mb-4">
                <div className="flex gap-4 mb-2 justify-end">
                    <h3 className="font-medium">Ave. Score: </h3>
                    <Rate size="small" disabled={true} allowHalf defaultValue={ scoreData?.jar_score / 20 } />
                    <div className="font-medium">{ scoreData?.jar_score }</div>
                </div>
                <p className={expanded ? "" : "line-clamp-3"}>
                    {scoreData?.jar_message}
                </p>
                {isClientUser && 
                <button
                    className="text-blue-500"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? "Show less" : "Show more"}
                </button>
                }
            </Card>
            {!isClientUser && <>
                <h3 className="px-4 py-2 font-medium text-[18px]">Scores Breakdown</h3>
                <Collapse items={items} defaultActiveKey={['1']} />
                </>
            }
            
        </div>
    );
};

export default CandidateScoreCard;
